// server urls
export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL
export const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD

export const API_URL = process.env.REACT_APP_API_URL;
export const HYPERSCOUT_BACKEND_URL = process.env.REACT_APP_HYPERSCOUT_BACKEND_URL;
export const API_TOKEN = process.env.REACT_APP_AUTHORIZATION;
export const FNAD_PRODUCION_API = process.env.REACT_APP_FNAD_PRODUCION_API;
export const AI_BACKEND_API = process.env.REACT_APP_AI_BACKEND_API;
export const NEST_BACKEND_API = process.env.REACT_APP_NEST_BACKEND_API;
export const BUCKET_NAME = process.env.REACT_APP_BUCKET_NAME;
export const SECRET_ACCESS_KEY = process.env.REACT_APP_SECRET_ACCESS_KEY;
export const ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
export const BUCKET_REGION = process.env.REACT_APP_BUCKET_REGION;
export const AI_BACKEND_API_2 = process.env.REACT_APP_AI_BACKEND_API_2;
export const COMPANY_APP_URL = process.env.REACT_APP_COMPANY_APP_URL;